import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportCard = ({ report, onGenerate, onSchedule, onView }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'ready':
        return {
          text: 'text-success',
          bg: 'bg-success/10',
          border: 'border-success/20',
          icon: 'CheckCircle'
        };
      case 'generating':
        return {
          text: 'text-warning',
          bg: 'bg-warning/10',
          border: 'border-warning/20',
          icon: 'Loader'
        };
      case 'scheduled':
        return {
          text: 'text-primary',
          bg: 'bg-primary/10',
          border: 'border-primary/20',
          icon: 'Calendar'
        };
      default:
        return {
          text: 'text-muted-foreground',
          bg: 'bg-muted/10',
          border: 'border-border',
          icon: 'Clock'
        };
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'ready':
        return 'Pronto';
      case 'generating':
        return 'Gerando';
      case 'scheduled':
        return 'Agendado';
      default:
        return 'Pendente';
    }
  };

  const getFormatIcon = (format) => {
    switch (format.toLowerCase()) {
      case 'pdf':
        return 'FileText';
      case 'excel':
        return 'Table';
      case 'csv':
        return 'FileSpreadsheet';
      default:
        return 'File';
    }
  };

  const statusConfig = getStatusColor(report.status);

  return (
    <div className="group relative bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl opacity-20 -mr-16 -mt-16 group-hover:opacity-30 transition-opacity"></div>

      <div className="relative">
        {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <Icon name={report.icon} size={24} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-bold text-foreground mb-1 group-hover:text-primary transition-colors">
                {report.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {report.description}
              </p>
            </div>
          </div>
          
          {/* Status badge */}
          <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg ${statusConfig.bg} ${statusConfig.border} border`}>
            <Icon name={statusConfig.icon} size={14} className={statusConfig.text} />
            <span className={`text-xs font-semibold ${statusConfig.text}`}>
              {getStatusText(report.status)}
            </span>
        </div>
      </div>

        {/* Report details */}
        <div className="space-y-3 mb-6">
        <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Clock" size={14} />
              <span>Última atualização</span>
            </div>
          <span className="text-foreground font-medium">{report.lastUpdated}</span>
        </div>
          
        <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Repeat" size={14} />
              <span>Frequência</span>
            </div>
          <span className="text-foreground font-medium">{report.frequency}</span>
        </div>
          
        <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name={getFormatIcon(report.format)} size={14} />
              <span>Formato</span>
            </div>
          <span className="text-foreground font-medium">{report.format}</span>
        </div>
      </div>

        {/* Action buttons */}
        <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="default"
          size="sm"
          onClick={() => onGenerate(report.id)}
          iconName="Play"
          iconPosition="left"
          disabled={report.status === 'generating'}
            className="flex-1 min-w-0"
        >
            <span className="truncate">Gerar</span>
        </Button>
          
        <Button
          variant="outline"
          size="sm"
          onClick={() => onView(report.id)}
          iconName="Eye"
          iconPosition="left"
            className="flex-1 min-w-0"
        >
            <span className="truncate">Visualizar</span>
        </Button>
          
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onSchedule(report.id)}
          iconName="Calendar"
          iconPosition="left"
            className="flex-1 min-w-0"
        >
            <span className="truncate">Agendar</span>
        </Button>
        </div>

        {/* Hover effect overlay */}
        <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-xl pointer-events-none"></div>
      </div>
    </div>
  );
};

export default ReportCard;